import { UploadCardFile } from '@axa-asia/emma-stylesheet/lib/components/EmmaMolecules/EmmaUploadCard';
import { useEmmaJS } from './useEmmaJS';
import { getFileExt, isEmmaApp } from '../helpers/common';
import { dataUrlToBlob } from '../helpers/dataUrlToBlob';
import { useCallback } from 'react';

export const useOpenPreviewFile = () => {
  const emmajs = useEmmaJS();

  return useCallback(
    (file: UploadCardFile) => {
      if (!emmajs) return;
      const {
        file: { name, uri },
        dataUrl,
      } = file;
      const ext = getFileExt(name);

      if (isEmmaApp) {
        dataUrl
          ? emmajs?.instance?.openFile(dataUrl, ext, name)
          : emmajs?.instance?.openFileUri(uri, name);
      } else {
        const fileUrl = URL.createObjectURL(dataUrlToBlob(dataUrl));
        const w = window.open(fileUrl, '_blank');
        w.addEventListener('load', () => {
          w.document.title = name;
        });
      }
    },
    [emmajs],
  );
};
